"use strict";
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}
function SetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}

    !function () {

        var _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
            return typeof e === "undefined" ? "undefined" : _typeof2(e);
        } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof2(e);
        };Vue.use(VueDataScooper), $.fn.hasExtension = function (e) {
            var t = "(.*?)\\.(" + e.join("|") + ")$";return new RegExp(t).test($(this).val().toLowerCase());
        };

            var App = { func: {
                    statistcsRed:function statistcsRed(){
                        console.log('тут');
                    },
                    SetFilter:function SetFilter(){
                        let ogrnInput=I('ogrn');
                        let docTypeSelect=I('SelDoc');
                        let url = new URLSearchParams(document.location.search);
                        if (ogrnInput!==null  && ogrnInput.value!=''){
                            if (url.has('ogrn')){
                                url.set('ogrn',ogrnInput.value);
                            }else{
                                url.append('ogrn', ogrnInput.value);
                            }
                        }

                        if (docTypeSelect!==null && docTypeSelect.value!=''){
                            if (url.has('doc')){
                                url.set('doc',docTypeSelect.value);
                                console.log(docTypeSelect.value);
                            }else{
                                url.append('doc', docTypeSelect.value);
                            }
                        }
                        if (url.has('page')){
                            url.delete('page');
                        }

                        document.location.search =url;
                    },
                PurgeURLParam:function PurgeURLParam(){
                    let url = new URLSearchParams(document.location.search);
                    let docTypeSelect=I('SelDoc');
                    let ogrnInput=I('ogrn');
                    if ((window.vm.$data.cabinet=='reg') || (window.vm.$data.cabinet=='school_reg')){
                        docTypeSelect.options[0].selected=true;
                    }
                    if (window.vm.$data.cabinet=='foiv'){

                    }
                    this.loading = false;
                    ogrnInput.value=url.get('ogrn');
                    if (url.has('ogrn')){
                        url.delete('ogrn');
                    }
                    if (url.has('doc')){
                        url.delete('doc');
                    }
                   /* if (url.has('page')){
                        App.func.setUrlPageParam(url.get('page'));
                    }else{
                        App.func.setUrlPageParam('0');
                    }*/
                    document.location.search =url;
                },


                setUrlPageParam: function setUrlPageParam(e) {
                    let url = new URLSearchParams(document.location.search);
                    console.log(e > 1);
                    if (e >= 1){
                        console.log(url.has('page'));
                        if (url.has('page')){
                            console.log(e);
                            url.set('page',e);
                        }else{
                            url.append('page', e);
                        }
                    }
                    console.log(url.toString());
                    document.location.search =url;
                },

                    reloadEl: function reloadEl(el) {
                    if (console.log("el", el), el.hasA("ref-after-reload")) {
                        var afterReload = el.A("ref-after-reload");
                        return el.reloadIt(!1).then(function () {
                            console.log(afterReload);
                            eval(afterReload);
                        });
                    }
                       // console.log('тут');
                    return el.reloadIt(!1);
                },
                    fillVueFormErrors: function fillVueFormErrors(e, t)
                    {},

                    selectClearElement: function selectClearElement(e) {
                    e.innerHTML = e.A("placeholder");
                },
                    selectClearElementWithVue: function selectClearElementWithVue(e, t, n) {
                    this.selectClearElement(e);for (var o = t, r = n.split("."), i = r.length - 1, l = 0; l < i; l++) {
                        o = o[r[l]];
                    }o[r[i]] = null;

                },
                    selectReloadElement: function selectReloadElement(e, t) {
                    var n = e.previousElementSibling;if (t) {
                        var o = n.A("selfref");if ("object" === ("undefined" == typeof t ? "undefined" : _typeof(t))) for (var r in t) {
                            t.hasOwnProperty(r) && (o = o.setURLParam(r, t[r]));
                        } else o = o.setURLParam("id", t);n.setA("selfref", o);
                    }
                },
                    onChooseWithVue: function onChooseWithVue(e, t, n, o) {
                    e.previousSibling.previousSibling.innerHTML = t.text, e.previousSibling.previousSibling.previousSibling.value = t.rid, n[o] = t.rid;
                }, reloadElementWithData: function reloadElementWithData(e, t) {
                    if ("string" == typeof e && (e = I(e)), void 0 !== ("undefined" == typeof t ? "undefined" : _typeof(t))) {
                        var n = e.A("ref-src");if ("object" === ("undefined" == typeof t ? "undefined" : _typeof(t))) for (var o in t) {
                            t.hasOwnProperty(o) && (n = n.setURLParam(o, t[o]));
                        } else n = n.setURLParam("id", t);e.setA("ref-src", n);
                    }return e.reloadIt(!1);
                }, reloadElementDelay: function reloadElementDelay(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;return new Promise(function (n, o) {
                        setTimeout(function () {
                            reloadElement(e, !1).then(function (e) {
                                n(e);
                            }).fail(o);
                        }, t);
                    });
                } }, handlers: { httpError: function httpError(e, t) {
                    return function (n) {
                        t || (t = e, e = null), e && e(), toastErr.show(n).then(function () {
                            t && t();
                        });
                    };
                } } };window.App = App;

        var newURL = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname;
        var pathArray = window.location.pathname.split( '/' );


    }();

